<template>
  <div>
    <ol class="breadcrumb">
      <li>
        <router-link to="/parcelamento">
          Alunos Captação
        </router-link>
      </li>
      <li class="active">
        Detalhes do aluno
      </li>
    </ol>
    <p class="admin-page-description">
      Detalhes de um aluno em captação/parcelamento. Use as abas pra
      alternar entre planos de pagamento e revisar dados pessoais,
      endereço, documentos enviados, dependentes e proposta financeira.
      Aqui você acompanha o fluxo de matrícula até a contratação.
    </p>
    <div class="panel panel-primary">
      <div class="panel-body">
        <ul class="nav nav-tabs">
          <li
            class="tabulated-list"
            role="presentation"
            v-for="(paymentPlan, index) in student.paymentPlans"
            :key="index"
            :class="{ active: index === selectedPaymentPlanIndex }"
          >
            <a data-toggle="tab" class="tab-anchor" @click="selectedPaymentPlanIndex = index">
              Plano de captação: {{ paymentPlan.id }}
              <span class="badge badge-circle badge-warning">
                {{ paymentPlan.translatedPlanType }}
              </span>
            </a>
          </li>
        </ul>
        <div class="tab-content" v-if="student.paymentPlans">
          <section>
            <payment-plan
              :student="student"
              :payment-plan="student.paymentPlans[selectedPaymentPlanIndex]"
              :gender-options="genderOptions"
              :marital-status-options="maritalStatusOptions"
              @update-payment-plan-status="updatePaymentPlanStatus($event)"
            />
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';
  .tab-anchor {
    cursor: pointer;
  }

  .tab-content {
    margin-top: $space-m;
  }
  .badge-warning {
    background-color: #DEBF00;
  }
</style>
<script>
import ParcelamentoService from 'services/ParcelamentoService';
import PaymentPlan from 'pages/Parcelamento/StudentView/PaymentPlanData/PaymentPlan';

export default {
  components: {
    PaymentPlan,
  },
  data() {
    return {
      student: {},
      genderOptions: [],
      maritalStatusOptions: [],
      selectedPaymentPlanIndex: 0,
    };
  },
  created() {
    this.$loader.show();
    ParcelamentoService.getStudent(this.$route.params.id)
      .then((student) => {
        this.student = student;
        return Promise.all(this.student.paymentPlans.map(async (paymentPlan) => {
          const documents = await ParcelamentoService.getDocuments(paymentPlan.id);
          this.$set(paymentPlan, 'documents', documents);
          return Promise.resolve();
        }));
      })
      .catch(() => {
        this.$router.push('/parcelamento');
      })
      .finally(() => {
        this.$loader.hide();
      });
  },
  mounted() {
    ParcelamentoService.getGenders()
      .then((gender) => {
        this.genderOptions = gender;
      });
    ParcelamentoService.getMaritalStatus()
      .then((maritalStatus) => {
        this.maritalStatusOptions = maritalStatus;
      });
  },
  methods: {
    updatePaymentPlanStatus(status) {
      this.student.paymentPlans[this.selectedPaymentPlanIndex].status = status.status;
      this.student.paymentPlans[this.selectedPaymentPlanIndex].translatedStatus = status.translatedStatus;
    },
    canAddDocument(documentAddedBefore, document) {
      return (!documentAddedBefore || documentAddedBefore.id < document.id);
    },
    parseDocuments(documents) {
      const documentGroupedByOwnerAndKind = {};
      documents.forEach((document) => {
        if (!documentGroupedByOwnerAndKind[document.owner]) {
          documentGroupedByOwnerAndKind[document.owner] = {};
        }
        if (this.canAddDocument(documentGroupedByOwnerAndKind[document.owner][document.kind], document)) {
          documentGroupedByOwnerAndKind[document.owner][document.kind] = document;
        }
      });
      const ownerKeys = Object.keys(documentGroupedByOwnerAndKind);
      const documentsArray = [];
      ownerKeys.forEach((key) => {
        const entityKeys = Object.keys(documentGroupedByOwnerAndKind[key]);
        entityKeys.forEach((entityKey) => {
          documentsArray.push(documentGroupedByOwnerAndKind[key][entityKey]);
        });
      });
      return documentsArray;
    },
  },
};
</script>
